import React from 'react';

/**
 * @typedef {object} DataPointInfoDetailsProps
 * @property {Object} dataPoint
 * @property {string} [measurementName]
 */

/**
 * @param {DataPointInfoDetailsProps} props
 */
const DataPointInfoDetails = props => {
  const { dataPoint, measurementName } = props;
  const notes = dataPoint.Notes ? dataPoint.Notes : 'N/A';

  return (
    <>
      <span className='graph-name'>{measurementName ? measurementName : dataPoint.Name}</span>
      <div className='graph-info'>
        <p>
          <strong>Date: </strong>
          {dataPoint.Date}
        </p>
        <p>
          <strong>Reporter: </strong>
          {dataPoint.ReporterName}
        </p>
        <p>
          <strong>Notes: </strong>
        </p>
        <p>{notes}</p>
      </div>
    </>
  );
};

export default DataPointInfoDetails;
